<template>
  <div id="app">
    <NavBar />
    <router-view></router-view>
    <Footer FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import NavBar from "./components/cyberfire/NavBar";
import Footer from "./components/cyberfire/Footer";
export default {
  name: "app",
  components: {
    NavBar,
    Footer,
  },
};
</script>

